import React, { useState } from "react";
import { Collapse, Divider, List, ListItem, ListItemIcon, ListItemText, Typography, Tooltip, useMediaQuery, useTheme } from "@material-ui/core";
import { Inbox as InboxIcon } from "@material-ui/icons";
import { Link } from "react-router-dom";
import classnames from "classnames";

// styles
import useStyles from "./styles";
import { withStyles } from "@material-ui/core/styles";

// components
import Dot from "../Dot";

const LightTooltip = withStyles((theme) => ({
	tooltip: {
		backgroundColor: theme.palette.common.white,
		color: "rgba(0, 0, 0, 0.87)",
		boxShadow: theme.shadows[1],
		fontSize: 15,
		padding: "6px 10px",
	},
}))(Tooltip);

export default function SidebarLink({ link, icon, label, children, location, onToggleSidebar, isSidebarOpened, nested, type }) {
	var classes = useStyles();
	const theme = useTheme();
	const isMobile = useMediaQuery(theme.breakpoints.down('xs'));
	// local
	var [isOpen, setIsOpen] = useState(false);
	var isLinkActive = link && (location.pathname === link || location.pathname.indexOf(link) !== -1);
	
	if (type === "title")
		return (
			<Typography
				className={classnames(classes.linkText, classes.sectionTitle, {
					[classes.linkTextHidden]: !isSidebarOpened,
				})}>
				{label}
			</Typography>
		);

	if (type === "divider") return <Divider className={classes.divider} />;

	if (!children)
		return (
			<ListItem
				button
				component={link && Link}
				to={link}
				className={classes.link}
				classes={{
					root: classnames(classes.linkRoot, {
						[classes.linkActive]: isLinkActive && !nested,
						[classes.linkNested]: nested,
					}),
				}}
				onClick={isMobile ? () => onToggleSidebar(isSidebarOpened) : null}
				disableRipple>
				<LightTooltip title={label} placement="right">
					<ListItemIcon
						className={classnames(classes.linkIcon, {
							[classes.linkIconActive]: isLinkActive,
						})}>
						{nested ? <Dot color={isLinkActive && "primary"} /> : icon}
					</ListItemIcon>
				</LightTooltip>
				<ListItemText
					classes={{
						primary: classnames(classes.linkText, {
							[classes.linkTextActive]: isLinkActive,
							[classes.linkTextHidden]: !isSidebarOpened,
						}),
					}}
					primary={label}
				/>
			</ListItem>
		);

	return (
		<>
			<ListItem button component={link && Link} onClick={toggleCollapse} className={classes.link} to={link} disableRipple>
				<ListItemIcon
					className={classnames(classes.linkIcon, {
						[classes.linkIconActive]: isLinkActive,
					})}>
					{icon ? icon : <InboxIcon />}
				</ListItemIcon>
				<ListItemText
					classes={{
						primary: classnames(classes.linkText, {
							[classes.linkTextActive]: isLinkActive,
							[classes.linkTextHidden]: !isSidebarOpened,
						}),
					}}
					primary={label}
				/>
			</ListItem>
			{children && (
				<Collapse in={isOpen && isSidebarOpened} timeout="auto" unmountOnExit className={classes.nestedList}>
					<List component="div" disablePadding>
						{children.map((childrenLink) => (
							<SidebarLink key={childrenLink && childrenLink.link} location={location} isSidebarOpened={isSidebarOpened} classes={classes} nested {...childrenLink} />
						))}
					</List>
				</Collapse>
			)}
		</>
	);

	// ###########################################################

	function toggleCollapse(e) {
		if (isSidebarOpened) {
			e.preventDefault();
			setIsOpen(!isOpen);
		}
	}
}
